import * as Types from '../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CheckGlItemsQueryVariables = Types.Exact<{
  modelId: Types.Scalars['String'];
  itemValues?: Types.InputMaybe<Array<Types.Scalars['NodeValue']> | Types.Scalars['NodeValue']>;
  glType: Types.Scalars['String'];
  glNodeId?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type CheckGlItemsQuery = { glItems: { message: string, success: boolean, codes?: Array<string> | null } };

export type CheckInvalidGlsQueryVariables = Types.Exact<{
  modelId: Types.Scalars['String'];
  priceListId: Types.Scalars['String'];
}>;


export type CheckInvalidGlsQuery = { invalidGls: Array<{ id: string, code: string }> };

export type CheckGlMismatchQueryVariables = Types.Exact<{
  priceListId: Types.Scalars['String'];
}>;


export type CheckGlMismatchQuery = { glMismatch: Array<string> };

export type GetNodeIdByCodeQueryVariables = Types.Exact<{
  hierarchyId: Types.Scalars['String'];
  nodeCode: Types.Scalars['String'];
}>;


export type GetNodeIdByCodeQuery = { getNodeIdByCode?: string | null };

export type GetCompatiblePriceListsQueryVariables = Types.Exact<{
  modelId: Types.Scalars['String'];
  glId: Types.Scalars['String'];
}>;


export type GetCompatiblePriceListsQuery = { getCompatiblePriceLists: { disabledPriceListId?: string | null, compatibilePriceLists?: Array<{ id: string, listName: string }> | null, compatibilePriceListsZMAB?: Array<{ id: string, listName: string }> | null } };

export type GetModelHasDisabledItemsQueryVariables = Types.Exact<{
  modelId: Types.Scalars['String'];
}>;


export type GetModelHasDisabledItemsQuery = { modelHasDisabledItems: boolean };

export type CertificatePrototypeMutationVariables = Types.Exact<{
  prototypeId: Types.Scalars['String'];
  cgtModelVariables: Types.CgtModelVariables;
}>;


export type CertificatePrototypeMutation = { certificatePrototype?: { documentId?: string | null } | null };

export type CertificateNodeMutationVariables = Types.Exact<{
  aggregateId: Types.Scalars['String'];
  nodeId: Types.Scalars['String'];
}>;


export type CertificateNodeMutation = { certificateNode?: { documentId?: string | null, salesforceDocumentId?: string | null } | null };

export type PublishModelMutationVariables = Types.Exact<{
  aggregateId: Types.Scalars['String'];
  nodeId: Types.Scalars['String'];
  event: Types.IPublishModelEvent;
}>;


export type PublishModelMutation = { publishModel?: { documentId?: string | null, salesforceDocumentId?: string | null } | null };

export type AlignLongListsMutationVariables = Types.Exact<{
  prototypeId: Types.Scalars['String'];
  longListIds: Array<Types.Scalars['String']> | Types.Scalars['String'];
}>;


export type AlignLongListsMutation = { alignLongLists?: { code: string, message: string, success: boolean } | null };

export type AlignMismatchGlMutationVariables = Types.Exact<{
  modelId: Types.Scalars['String'];
}>;


export type AlignMismatchGlMutation = { alignMismatchGl?: { code: string, message: string, success: boolean } | null };

export type AlignLonglistsSectionsMutationVariables = Types.Exact<{
  sectionNodeId: Types.Scalars['String'];
  name: Types.Scalars['String'];
  description: Types.Scalars['String'];
  notes: Types.Scalars['String'];
}>;


export type AlignLonglistsSectionsMutation = { alignLonglistsSections?: { code: string, message: string, success: boolean } | null };

export type ReplaceItemMutationVariables = Types.Exact<{
  nodeId: Types.Scalars['String'];
  nodeCode: Types.Scalars['String'];
  newItemCode: Types.Scalars['String'];
}>;


export type ReplaceItemMutation = { replaceItem?: { code: string, message: string, success: boolean } | null };

export type ChangeGlPriceListMutationVariables = Types.Exact<{
  modelId: Types.Scalars['String'];
  glId: Types.Scalars['String'];
  disabledPriceListId?: Types.InputMaybe<Types.Scalars['String']>;
  priceListId?: Types.InputMaybe<Types.Scalars['String']>;
  priceListIdZMAB?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type ChangeGlPriceListMutation = { changeGlPriceList?: { code: string, success: boolean, message: string } | null };

export type SaveShortListPdfColumnsMutationVariables = Types.Exact<{
  shortListNodeId: Types.Scalars['String'];
  familyNodeId: Types.Scalars['String'];
  columns: Array<Types.ShortListPdfColumnInput> | Types.ShortListPdfColumnInput;
  headers: Array<Types.ShortListEditableHeadersInput> | Types.ShortListEditableHeadersInput;
}>;


export type SaveShortListPdfColumnsMutation = { saveShortListPdfColumns?: { code: string, success: boolean, message: string } | null };


export const CheckGlItemsDocument = gql`
    query checkGlItems($modelId: String!, $itemValues: [NodeValue!], $glType: String!, $glNodeId: String) {
  glItems(
    modelId: $modelId
    itemValues: $itemValues
    glType: $glType
    glNodeId: $glNodeId
  ) {
    message
    success
    codes
  }
}
    `;

/**
 * __useCheckGlItemsQuery__
 *
 * To run a query within a React component, call `useCheckGlItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckGlItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckGlItemsQuery({
 *   variables: {
 *      modelId: // value for 'modelId'
 *      itemValues: // value for 'itemValues'
 *      glType: // value for 'glType'
 *      glNodeId: // value for 'glNodeId'
 *   },
 * });
 */
export function useCheckGlItemsQuery(baseOptions: Apollo.QueryHookOptions<CheckGlItemsQuery, CheckGlItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckGlItemsQuery, CheckGlItemsQueryVariables>(CheckGlItemsDocument, options);
      }
export function useCheckGlItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckGlItemsQuery, CheckGlItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckGlItemsQuery, CheckGlItemsQueryVariables>(CheckGlItemsDocument, options);
        }
export type CheckGlItemsQueryHookResult = ReturnType<typeof useCheckGlItemsQuery>;
export type CheckGlItemsLazyQueryHookResult = ReturnType<typeof useCheckGlItemsLazyQuery>;
export type CheckGlItemsQueryResult = Apollo.QueryResult<CheckGlItemsQuery, CheckGlItemsQueryVariables>;
export const CheckInvalidGlsDocument = gql`
    query checkInvalidGls($modelId: String!, $priceListId: String!) {
  invalidGls(modelId: $modelId, priceListId: $priceListId) {
    id
    code
  }
}
    `;

/**
 * __useCheckInvalidGlsQuery__
 *
 * To run a query within a React component, call `useCheckInvalidGlsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckInvalidGlsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckInvalidGlsQuery({
 *   variables: {
 *      modelId: // value for 'modelId'
 *      priceListId: // value for 'priceListId'
 *   },
 * });
 */
export function useCheckInvalidGlsQuery(baseOptions: Apollo.QueryHookOptions<CheckInvalidGlsQuery, CheckInvalidGlsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckInvalidGlsQuery, CheckInvalidGlsQueryVariables>(CheckInvalidGlsDocument, options);
      }
export function useCheckInvalidGlsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckInvalidGlsQuery, CheckInvalidGlsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckInvalidGlsQuery, CheckInvalidGlsQueryVariables>(CheckInvalidGlsDocument, options);
        }
export type CheckInvalidGlsQueryHookResult = ReturnType<typeof useCheckInvalidGlsQuery>;
export type CheckInvalidGlsLazyQueryHookResult = ReturnType<typeof useCheckInvalidGlsLazyQuery>;
export type CheckInvalidGlsQueryResult = Apollo.QueryResult<CheckInvalidGlsQuery, CheckInvalidGlsQueryVariables>;
export const CheckGlMismatchDocument = gql`
    query CheckGlMismatch($priceListId: String!) {
  glMismatch(priceListId: $priceListId)
}
    `;

/**
 * __useCheckGlMismatchQuery__
 *
 * To run a query within a React component, call `useCheckGlMismatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckGlMismatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckGlMismatchQuery({
 *   variables: {
 *      priceListId: // value for 'priceListId'
 *   },
 * });
 */
export function useCheckGlMismatchQuery(baseOptions: Apollo.QueryHookOptions<CheckGlMismatchQuery, CheckGlMismatchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckGlMismatchQuery, CheckGlMismatchQueryVariables>(CheckGlMismatchDocument, options);
      }
export function useCheckGlMismatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckGlMismatchQuery, CheckGlMismatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckGlMismatchQuery, CheckGlMismatchQueryVariables>(CheckGlMismatchDocument, options);
        }
export type CheckGlMismatchQueryHookResult = ReturnType<typeof useCheckGlMismatchQuery>;
export type CheckGlMismatchLazyQueryHookResult = ReturnType<typeof useCheckGlMismatchLazyQuery>;
export type CheckGlMismatchQueryResult = Apollo.QueryResult<CheckGlMismatchQuery, CheckGlMismatchQueryVariables>;
export const GetNodeIdByCodeDocument = gql`
    query GetNodeIdByCode($hierarchyId: String!, $nodeCode: String!) {
  getNodeIdByCode(hierarchyId: $hierarchyId, nodeCode: $nodeCode)
}
    `;

/**
 * __useGetNodeIdByCodeQuery__
 *
 * To run a query within a React component, call `useGetNodeIdByCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNodeIdByCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNodeIdByCodeQuery({
 *   variables: {
 *      hierarchyId: // value for 'hierarchyId'
 *      nodeCode: // value for 'nodeCode'
 *   },
 * });
 */
export function useGetNodeIdByCodeQuery(baseOptions: Apollo.QueryHookOptions<GetNodeIdByCodeQuery, GetNodeIdByCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNodeIdByCodeQuery, GetNodeIdByCodeQueryVariables>(GetNodeIdByCodeDocument, options);
      }
export function useGetNodeIdByCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNodeIdByCodeQuery, GetNodeIdByCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNodeIdByCodeQuery, GetNodeIdByCodeQueryVariables>(GetNodeIdByCodeDocument, options);
        }
export type GetNodeIdByCodeQueryHookResult = ReturnType<typeof useGetNodeIdByCodeQuery>;
export type GetNodeIdByCodeLazyQueryHookResult = ReturnType<typeof useGetNodeIdByCodeLazyQuery>;
export type GetNodeIdByCodeQueryResult = Apollo.QueryResult<GetNodeIdByCodeQuery, GetNodeIdByCodeQueryVariables>;
export const GetCompatiblePriceListsDocument = gql`
    query GetCompatiblePriceLists($modelId: String!, $glId: String!) {
  getCompatiblePriceLists(modelId: $modelId, glId: $glId) {
    compatibilePriceLists {
      id
      listName
    }
    compatibilePriceListsZMAB {
      id
      listName
    }
    disabledPriceListId
  }
}
    `;

/**
 * __useGetCompatiblePriceListsQuery__
 *
 * To run a query within a React component, call `useGetCompatiblePriceListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompatiblePriceListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompatiblePriceListsQuery({
 *   variables: {
 *      modelId: // value for 'modelId'
 *      glId: // value for 'glId'
 *   },
 * });
 */
export function useGetCompatiblePriceListsQuery(baseOptions: Apollo.QueryHookOptions<GetCompatiblePriceListsQuery, GetCompatiblePriceListsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompatiblePriceListsQuery, GetCompatiblePriceListsQueryVariables>(GetCompatiblePriceListsDocument, options);
      }
export function useGetCompatiblePriceListsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompatiblePriceListsQuery, GetCompatiblePriceListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompatiblePriceListsQuery, GetCompatiblePriceListsQueryVariables>(GetCompatiblePriceListsDocument, options);
        }
export type GetCompatiblePriceListsQueryHookResult = ReturnType<typeof useGetCompatiblePriceListsQuery>;
export type GetCompatiblePriceListsLazyQueryHookResult = ReturnType<typeof useGetCompatiblePriceListsLazyQuery>;
export type GetCompatiblePriceListsQueryResult = Apollo.QueryResult<GetCompatiblePriceListsQuery, GetCompatiblePriceListsQueryVariables>;
export const GetModelHasDisabledItemsDocument = gql`
    query GetModelHasDisabledItems($modelId: String!) {
  modelHasDisabledItems(modelId: $modelId)
}
    `;

/**
 * __useGetModelHasDisabledItemsQuery__
 *
 * To run a query within a React component, call `useGetModelHasDisabledItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModelHasDisabledItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModelHasDisabledItemsQuery({
 *   variables: {
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useGetModelHasDisabledItemsQuery(baseOptions: Apollo.QueryHookOptions<GetModelHasDisabledItemsQuery, GetModelHasDisabledItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetModelHasDisabledItemsQuery, GetModelHasDisabledItemsQueryVariables>(GetModelHasDisabledItemsDocument, options);
      }
export function useGetModelHasDisabledItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetModelHasDisabledItemsQuery, GetModelHasDisabledItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetModelHasDisabledItemsQuery, GetModelHasDisabledItemsQueryVariables>(GetModelHasDisabledItemsDocument, options);
        }
export type GetModelHasDisabledItemsQueryHookResult = ReturnType<typeof useGetModelHasDisabledItemsQuery>;
export type GetModelHasDisabledItemsLazyQueryHookResult = ReturnType<typeof useGetModelHasDisabledItemsLazyQuery>;
export type GetModelHasDisabledItemsQueryResult = Apollo.QueryResult<GetModelHasDisabledItemsQuery, GetModelHasDisabledItemsQueryVariables>;
export const CertificatePrototypeDocument = gql`
    mutation CertificatePrototype($prototypeId: String!, $cgtModelVariables: CgtModelVariables!) {
  certificatePrototype(
    prototypeId: $prototypeId
    cgtModelVariables: $cgtModelVariables
  ) {
    documentId
  }
}
    `;
export type CertificatePrototypeMutationFn = Apollo.MutationFunction<CertificatePrototypeMutation, CertificatePrototypeMutationVariables>;

/**
 * __useCertificatePrototypeMutation__
 *
 * To run a mutation, you first call `useCertificatePrototypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCertificatePrototypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [certificatePrototypeMutation, { data, loading, error }] = useCertificatePrototypeMutation({
 *   variables: {
 *      prototypeId: // value for 'prototypeId'
 *      cgtModelVariables: // value for 'cgtModelVariables'
 *   },
 * });
 */
export function useCertificatePrototypeMutation(baseOptions?: Apollo.MutationHookOptions<CertificatePrototypeMutation, CertificatePrototypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CertificatePrototypeMutation, CertificatePrototypeMutationVariables>(CertificatePrototypeDocument, options);
      }
export type CertificatePrototypeMutationHookResult = ReturnType<typeof useCertificatePrototypeMutation>;
export type CertificatePrototypeMutationResult = Apollo.MutationResult<CertificatePrototypeMutation>;
export type CertificatePrototypeMutationOptions = Apollo.BaseMutationOptions<CertificatePrototypeMutation, CertificatePrototypeMutationVariables>;
export const CertificateNodeDocument = gql`
    mutation CertificateNode($aggregateId: String!, $nodeId: String!) {
  certificateNode(aggregateId: $aggregateId, nodeId: $nodeId) {
    documentId
    salesforceDocumentId
  }
}
    `;
export type CertificateNodeMutationFn = Apollo.MutationFunction<CertificateNodeMutation, CertificateNodeMutationVariables>;

/**
 * __useCertificateNodeMutation__
 *
 * To run a mutation, you first call `useCertificateNodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCertificateNodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [certificateNodeMutation, { data, loading, error }] = useCertificateNodeMutation({
 *   variables: {
 *      aggregateId: // value for 'aggregateId'
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useCertificateNodeMutation(baseOptions?: Apollo.MutationHookOptions<CertificateNodeMutation, CertificateNodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CertificateNodeMutation, CertificateNodeMutationVariables>(CertificateNodeDocument, options);
      }
export type CertificateNodeMutationHookResult = ReturnType<typeof useCertificateNodeMutation>;
export type CertificateNodeMutationResult = Apollo.MutationResult<CertificateNodeMutation>;
export type CertificateNodeMutationOptions = Apollo.BaseMutationOptions<CertificateNodeMutation, CertificateNodeMutationVariables>;
export const PublishModelDocument = gql`
    mutation PublishModel($aggregateId: String!, $nodeId: String!, $event: IPublishModelEvent!) {
  publishModel(aggregateId: $aggregateId, nodeId: $nodeId, event: $event) {
    documentId
    salesforceDocumentId
  }
}
    `;
export type PublishModelMutationFn = Apollo.MutationFunction<PublishModelMutation, PublishModelMutationVariables>;

/**
 * __usePublishModelMutation__
 *
 * To run a mutation, you first call `usePublishModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishModelMutation, { data, loading, error }] = usePublishModelMutation({
 *   variables: {
 *      aggregateId: // value for 'aggregateId'
 *      nodeId: // value for 'nodeId'
 *      event: // value for 'event'
 *   },
 * });
 */
export function usePublishModelMutation(baseOptions?: Apollo.MutationHookOptions<PublishModelMutation, PublishModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishModelMutation, PublishModelMutationVariables>(PublishModelDocument, options);
      }
export type PublishModelMutationHookResult = ReturnType<typeof usePublishModelMutation>;
export type PublishModelMutationResult = Apollo.MutationResult<PublishModelMutation>;
export type PublishModelMutationOptions = Apollo.BaseMutationOptions<PublishModelMutation, PublishModelMutationVariables>;
export const AlignLongListsDocument = gql`
    mutation AlignLongLists($prototypeId: String!, $longListIds: [String!]!) {
  alignLongLists(prototypeId: $prototypeId, longListIds: $longListIds) {
    code
    message
    success
  }
}
    `;
export type AlignLongListsMutationFn = Apollo.MutationFunction<AlignLongListsMutation, AlignLongListsMutationVariables>;

/**
 * __useAlignLongListsMutation__
 *
 * To run a mutation, you first call `useAlignLongListsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlignLongListsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alignLongListsMutation, { data, loading, error }] = useAlignLongListsMutation({
 *   variables: {
 *      prototypeId: // value for 'prototypeId'
 *      longListIds: // value for 'longListIds'
 *   },
 * });
 */
export function useAlignLongListsMutation(baseOptions?: Apollo.MutationHookOptions<AlignLongListsMutation, AlignLongListsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AlignLongListsMutation, AlignLongListsMutationVariables>(AlignLongListsDocument, options);
      }
export type AlignLongListsMutationHookResult = ReturnType<typeof useAlignLongListsMutation>;
export type AlignLongListsMutationResult = Apollo.MutationResult<AlignLongListsMutation>;
export type AlignLongListsMutationOptions = Apollo.BaseMutationOptions<AlignLongListsMutation, AlignLongListsMutationVariables>;
export const AlignMismatchGlDocument = gql`
    mutation AlignMismatchGl($modelId: String!) {
  alignMismatchGl(modelId: $modelId) {
    code
    message
    success
  }
}
    `;
export type AlignMismatchGlMutationFn = Apollo.MutationFunction<AlignMismatchGlMutation, AlignMismatchGlMutationVariables>;

/**
 * __useAlignMismatchGlMutation__
 *
 * To run a mutation, you first call `useAlignMismatchGlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlignMismatchGlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alignMismatchGlMutation, { data, loading, error }] = useAlignMismatchGlMutation({
 *   variables: {
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useAlignMismatchGlMutation(baseOptions?: Apollo.MutationHookOptions<AlignMismatchGlMutation, AlignMismatchGlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AlignMismatchGlMutation, AlignMismatchGlMutationVariables>(AlignMismatchGlDocument, options);
      }
export type AlignMismatchGlMutationHookResult = ReturnType<typeof useAlignMismatchGlMutation>;
export type AlignMismatchGlMutationResult = Apollo.MutationResult<AlignMismatchGlMutation>;
export type AlignMismatchGlMutationOptions = Apollo.BaseMutationOptions<AlignMismatchGlMutation, AlignMismatchGlMutationVariables>;
export const AlignLonglistsSectionsDocument = gql`
    mutation AlignLonglistsSections($sectionNodeId: String!, $name: String!, $description: String!, $notes: String!) {
  alignLonglistsSections(
    sectionNodeId: $sectionNodeId
    name: $name
    description: $description
    notes: $notes
  ) {
    code
    message
    success
  }
}
    `;
export type AlignLonglistsSectionsMutationFn = Apollo.MutationFunction<AlignLonglistsSectionsMutation, AlignLonglistsSectionsMutationVariables>;

/**
 * __useAlignLonglistsSectionsMutation__
 *
 * To run a mutation, you first call `useAlignLonglistsSectionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlignLonglistsSectionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alignLonglistsSectionsMutation, { data, loading, error }] = useAlignLonglistsSectionsMutation({
 *   variables: {
 *      sectionNodeId: // value for 'sectionNodeId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useAlignLonglistsSectionsMutation(baseOptions?: Apollo.MutationHookOptions<AlignLonglistsSectionsMutation, AlignLonglistsSectionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AlignLonglistsSectionsMutation, AlignLonglistsSectionsMutationVariables>(AlignLonglistsSectionsDocument, options);
      }
export type AlignLonglistsSectionsMutationHookResult = ReturnType<typeof useAlignLonglistsSectionsMutation>;
export type AlignLonglistsSectionsMutationResult = Apollo.MutationResult<AlignLonglistsSectionsMutation>;
export type AlignLonglistsSectionsMutationOptions = Apollo.BaseMutationOptions<AlignLonglistsSectionsMutation, AlignLonglistsSectionsMutationVariables>;
export const ReplaceItemDocument = gql`
    mutation ReplaceItem($nodeId: String!, $nodeCode: String!, $newItemCode: String!) {
  replaceItem(nodeId: $nodeId, nodeCode: $nodeCode, newItemCode: $newItemCode) {
    code
    message
    success
  }
}
    `;
export type ReplaceItemMutationFn = Apollo.MutationFunction<ReplaceItemMutation, ReplaceItemMutationVariables>;

/**
 * __useReplaceItemMutation__
 *
 * To run a mutation, you first call `useReplaceItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplaceItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replaceItemMutation, { data, loading, error }] = useReplaceItemMutation({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *      nodeCode: // value for 'nodeCode'
 *      newItemCode: // value for 'newItemCode'
 *   },
 * });
 */
export function useReplaceItemMutation(baseOptions?: Apollo.MutationHookOptions<ReplaceItemMutation, ReplaceItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplaceItemMutation, ReplaceItemMutationVariables>(ReplaceItemDocument, options);
      }
export type ReplaceItemMutationHookResult = ReturnType<typeof useReplaceItemMutation>;
export type ReplaceItemMutationResult = Apollo.MutationResult<ReplaceItemMutation>;
export type ReplaceItemMutationOptions = Apollo.BaseMutationOptions<ReplaceItemMutation, ReplaceItemMutationVariables>;
export const ChangeGlPriceListDocument = gql`
    mutation ChangeGlPriceList($modelId: String!, $glId: String!, $disabledPriceListId: String, $priceListId: String, $priceListIdZMAB: String) {
  changeGlPriceList(
    modelId: $modelId
    glId: $glId
    disabledPriceListId: $disabledPriceListId
    priceListId: $priceListId
    priceListIdZMAB: $priceListIdZMAB
  ) {
    code
    success
    message
  }
}
    `;
export type ChangeGlPriceListMutationFn = Apollo.MutationFunction<ChangeGlPriceListMutation, ChangeGlPriceListMutationVariables>;

/**
 * __useChangeGlPriceListMutation__
 *
 * To run a mutation, you first call `useChangeGlPriceListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeGlPriceListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeGlPriceListMutation, { data, loading, error }] = useChangeGlPriceListMutation({
 *   variables: {
 *      modelId: // value for 'modelId'
 *      glId: // value for 'glId'
 *      disabledPriceListId: // value for 'disabledPriceListId'
 *      priceListId: // value for 'priceListId'
 *      priceListIdZMAB: // value for 'priceListIdZMAB'
 *   },
 * });
 */
export function useChangeGlPriceListMutation(baseOptions?: Apollo.MutationHookOptions<ChangeGlPriceListMutation, ChangeGlPriceListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeGlPriceListMutation, ChangeGlPriceListMutationVariables>(ChangeGlPriceListDocument, options);
      }
export type ChangeGlPriceListMutationHookResult = ReturnType<typeof useChangeGlPriceListMutation>;
export type ChangeGlPriceListMutationResult = Apollo.MutationResult<ChangeGlPriceListMutation>;
export type ChangeGlPriceListMutationOptions = Apollo.BaseMutationOptions<ChangeGlPriceListMutation, ChangeGlPriceListMutationVariables>;
export const SaveShortListPdfColumnsDocument = gql`
    mutation SaveShortListPdfColumns($shortListNodeId: String!, $familyNodeId: String!, $columns: [ShortListPdfColumnInput!]!, $headers: [ShortListEditableHeadersInput!]!) {
  saveShortListPdfColumns(
    shortListNodeId: $shortListNodeId
    familyNodeId: $familyNodeId
    columns: $columns
    headers: $headers
  ) {
    code
    success
    message
  }
}
    `;
export type SaveShortListPdfColumnsMutationFn = Apollo.MutationFunction<SaveShortListPdfColumnsMutation, SaveShortListPdfColumnsMutationVariables>;

/**
 * __useSaveShortListPdfColumnsMutation__
 *
 * To run a mutation, you first call `useSaveShortListPdfColumnsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveShortListPdfColumnsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveShortListPdfColumnsMutation, { data, loading, error }] = useSaveShortListPdfColumnsMutation({
 *   variables: {
 *      shortListNodeId: // value for 'shortListNodeId'
 *      familyNodeId: // value for 'familyNodeId'
 *      columns: // value for 'columns'
 *      headers: // value for 'headers'
 *   },
 * });
 */
export function useSaveShortListPdfColumnsMutation(baseOptions?: Apollo.MutationHookOptions<SaveShortListPdfColumnsMutation, SaveShortListPdfColumnsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveShortListPdfColumnsMutation, SaveShortListPdfColumnsMutationVariables>(SaveShortListPdfColumnsDocument, options);
      }
export type SaveShortListPdfColumnsMutationHookResult = ReturnType<typeof useSaveShortListPdfColumnsMutation>;
export type SaveShortListPdfColumnsMutationResult = Apollo.MutationResult<SaveShortListPdfColumnsMutation>;
export type SaveShortListPdfColumnsMutationOptions = Apollo.BaseMutationOptions<SaveShortListPdfColumnsMutation, SaveShortListPdfColumnsMutationVariables>;